<template>
	<div id="headerWrapper">
		<header>
		</header>
	</div>
</template>
<script>
export default {
};
</script>
<style lang="sass">
#headerWrapper
	header
</style>



// WEBPACK FOOTER //
// src/components/Header.vue